import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { BasesOutputDTO } from './basesDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class BasesServices {
  async getByAll(params: any): Promise<BasesOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/bases/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const basesServices = new BasesServices()
